import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Flex, Box, Copy, Image, themeColor, themeFontSize } from '@elparking/components'

const CancelationInfoWrapper = styled(Flex)`
    background: ${themeColor('white')};
    font-size: ${themeFontSize('xxSmall')};
`

export default () => (
    <CancelationInfoWrapper p='16px 16px 0 16px' alignItems='center'>
        <Flex alignItems='center' mr='0.5em'>
            <Image width='1.6em' height='1.6em' src='/images/booking-process/icon-highlight-check.svg' alt='Ok' />
        </Flex>
        <Box>
            <Copy size='xxSmall' fontWeight='book' padding='0'>
                <FormattedMessage
                  defaultMessage='Cancelación gratuita hasta 24 horas del inicio de tu reserva'
                />
            </Copy>
        </Box>
    </CancelationInfoWrapper>
)
